
namespace TabAurous.Inventory {
    import fld = StockAllocatedBOMRow.Fields;
    @Serenity.Decorators.registerClass()
    export class StockAllocatedBOMEditor extends _Ext.BOMGridEditor<StockAllocatedBOMRow> { 
        protected getDialogType() { return StockAllocatedBOMDialog; }
        protected getLocalTextPrefix() { return StockAllocatedBOMRow.localTextPrefix; }
    
       

    }
}